import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudButtonModule,
	FreudLoaderModule,
	FreudSelectButtonModule,
	FreudToastModule,
	FreudTooltipModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { ModalSidebarModule } from '../../../../shared/components/modal-sidebar/modal-sidebar.module';
import { AppointmentFormModule } from '../appointment-form/appointment-form.module';
import { ConfirmActionBusySlotModule } from '../confirm-action-busy-slot/confirm-action-busy-slot.module';
import { ConflictInviteNewAppointmentModalModule } from '../conflict-invite-new-appointment-modal/conflict-invite-new-appointment-modal.module';
import { AppointmentSidebarComponent } from './appointment-sidebar.component';

@NgModule({
	declarations: [AppointmentSidebarComponent],
	imports: [
		CommonModule,
		ModalSidebarModule,
		TranslateModule.forChild(),
		FreudSelectButtonModule,
		AppointmentFormModule,
		FreudButtonModule,
		FreudTooltipModule,
		FreudLoaderModule,
		FreudToastModule,
		ConfirmActionBusySlotModule,
		ConflictInviteNewAppointmentModalModule,
	],
	exports: [AppointmentSidebarComponent],
})
export class AppointmentSidebarModule {}
